// This matches the type `IValidatorOtherDictionary` from FlatFile. Sadly it
// isn't exported, so we have to recreate it here.
export type Validator = {
  validate: "required" | "select" | "unique" | "boolean";
};

export const DECIMAL_VALIDATOR = "^[0-9]*\\.?[0-9]+$";
export const INTEGER_VALIDATOR = "^[0-9]*$";
